import moment from "moment";

export function departureEndDate(startDate, days) {
  const start = moment(startDate, "YYYY-MM-DD", true);
  const count = Number(days);
  if (!start.isValid() || !Number.isSafeInteger(count) || count < 1)
    return null;
  const end = start.add(count - 1, "days");
  return end.isValid() && end.year() <= 9999 ? end.format("YYYY-MM-DD") : null;
}

export function departureDays(startDate, endDate) {
  const start = moment(startDate, "YYYY-MM-DD", true);
  const end = moment(endDate, "YYYY-MM-DD", true);
  if (!start.isValid() || !end.isValid() || end.isBefore(start)) return null;
  return end.diff(start, "days") + 1;
}
